import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType } from 'vue';
import { DataTableIcons } from '@/shared/components/dataTable/dataTableIcons';


export default /*@__PURE__*/_defineComponent({
  __name: 'DataTableIcon',
  props: {
  icon: {
    type: String as PropType<keyof typeof DataTableIcons>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(__props.icon), { class: "data-table-icon" }))
}
}

})